import React from 'react';
import { Dialog } from '@mui/material';
import AllocationsChart from './AllocationsChart';

const AllocationsChartModal = ({ open, toggle, data, name, allocation }) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <AllocationsChart data={data} name={name} toggle={toggle} allocationPercentage={allocation} />
    </Dialog>
  );
};

export default AllocationsChartModal;
